import type { ReactNode } from 'react'
import { HelpDialog } from '@alwindows/shared'
import { RouteAnnouncer } from '@alwindows/shared/a11y'
import { postSpareEmailHelp } from '@alwindows/shared/api/spareParts'

function describePath(pathname: string): string | null {
  if (pathname === '/' || pathname === '') return 'Spare parts catalog'
  if (pathname.startsWith('/cart')) return 'Cart'
  if (pathname.startsWith('/checkout')) return 'Checkout'
  return null
}

export function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="al-sp align-center">
      <RouteAnnouncer describePath={describePath} />
      <div className="al-sp__topbar">
        <HelpDialog onSubmit={postSpareEmailHelp} />
      </div>
      {children}
    </div>
  )
}
